module.exports = __webpack_public_path__ + "img/screenshot_new102.8fd4c620.png";